export enum SystemNoticeTypeLabel {
  account = "Account",
  cardExpired = "Card expired",
  interpreter = "Requires Interpreter"
}
